/**
 * Centralized utilities for processing recurrence options
 * Eliminates duplicate filtering logic across form components
 */
import { selectRecurrenceOptions } from 'data/meta/metaSelectors'

/**
 * Get unique recurrence options by filtering out duplicates based on interval-per combination
 * @param {Object} metaFiltersData - Meta filters data
 * @returns {Array} Array of unique recurrence options
 */
export const getUniqueRecurrenceOptions = (metaFiltersData = {}) => {
  const rawOptions = selectRecurrenceOptions(metaFiltersData)

  const uniqueOptions = []
  const seenKeys = new Set()

  rawOptions.forEach(option => {
    const uniqueKey = `${option.recurrenceInterval}-${option.recurrencePer}`

    if (!seenKeys.has(uniqueKey)) {
      seenKeys.add(uniqueKey)
      uniqueOptions.push(option)
    }
  })

  return uniqueOptions
}

/**
 * Find a recurrence option by its string key format
 * @param {Array} options - Array of recurrence options
 * @param {string} key - Key in format "Interval-Per" (e.g., "Week-1")
 * @returns {Object|null} Matching recurrence option or null
 */
export const findRecurrenceOptionByKey = (options, key) => {
  if (!key || !Array.isArray(options) || !options.length) return null
  return options.find(option => `${option.recurrenceInterval}-${option.recurrencePer}` === key) || null
}
